import * as api from '../apis/locations';
import { apiCall } from '~/lib/redux/api';
import { EntityActions, LocationActions } from './consts';
import { LocationNormalizer } from './normalize';
import { defaultTablePageSize } from '~/common/components/consts';


export function getLocationById(locationId: string) {
  return apiCall({
    actions: [
      LocationActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, LocationActions.LOAD_SUCCESS],
      LocationActions.LOAD_ERROR,
    ],
    normalizer: LocationNormalizer,
    fn: () => api.getLocationById(locationId),
  });
}

export function getOrgLocations(orgId: string, filter = null, offset = 0, limit = defaultTablePageSize) {
  return apiCall({
    actions: [
      LocationActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, LocationActions.LOAD_LIST_SUCCESS],
      LocationActions.LOAD_ERROR,
    ],
    normalizer: [LocationNormalizer],
    fn: () => api.getOrgLocations(orgId, filter, offset, limit),
  })
}

export function createLocation(orgId: string, data) {
  return apiCall({
    actions: [
      LocationActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, LocationActions.LOAD_SUCCESS],
      LocationActions.LOAD_ERROR,
    ],
    normalizer: LocationNormalizer,
    fn: () => api.createLocation(orgId, data),
  });
}

export function updateLocation(locationId: string, data) {
  return apiCall({
    actions: [
      LocationActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, LocationActions.LOAD_SUCCESS],
      LocationActions.LOAD_ERROR,
    ],
    normalizer: LocationNormalizer,
    fn: () => api.updateLocation(locationId, data),
  });
}

export function setLocationCurrentPage(page: number) {
  return {
    type: LocationActions.SET_CURRENT_PAGE,
    currentPage: page,
  }
}

